import { $byId } from "@de-xima/xima-common-js-dom";
import { parseNumber, parseString } from "@de-xima/xima-common-js-lang";
import jQuery from "jquery";

/**
 * @param progressBar Container element of the progress bar. If not given,
 * defaults to the progress bar of the progress dialog.
 * @returns The value of the progress bar in percent, from 0 to 100.
 */
export function getValue(progressBar?: JQuery): number {
  const actualProgressBar = progressBar ?? jQuery(".progress-dialog .fc-progress-bar");
  const value = parseNumber(actualProgressBar.data("value"));
  return Math.max(Math.min(value, 100), 0);
}

/**
 * Sets a value from 0 to 100 on the progress bar.
 * @param value Value (in percent) to set on the progress bar. From 0 to 100.
 * @param progressBar Container element of the progress bar. If not given,
 * defaults to the progress bar of the progress dialog.
 */
export function setValue(value: number, progressBar?: JQuery): void {
  const actualProgressBar = progressBar ?? jQuery(".progress-dialog .fc-progress-bar");
  const rounded = Math.round(Math.max(Math.min(value, 100), 0));
  const labelTemplate = parseString(actualProgressBar.data("labelTemplate"));
  const positive = actualProgressBar.find(".fc-pb-positive");
  const negative = actualProgressBar.find(".fc-pb-negative");
  const counterPositive = positive.find(".fc-pb-counter");
  const counterNegative = negative.find(".fc-pb-counter");
  const label = labelTemplate.replace("{value}", String(rounded));
  counterPositive.text(label);
  counterNegative.text(label);
  positive.css("width", `${rounded}%`);
  negative.css("width", `${100 - rounded}%`);
  actualProgressBar.data("value", rounded);
}

/**
 * Initializes the progress bar.
 * @param id ID of the container element of the progress bar
 */
export function init(id: string): void {
  const progressBar = $byId(id);
  setValue(getValue(progressBar), progressBar);
}
